<template>
<div>
  <button type="button" @click="toggle_visible"></button>
  <button id="remove_button" v-if="filter_has_values" @click="show_clean_modal">Borrar</button>
  <button id="search_button" ref="search" v-show="search_button_visible" @click="show_search">Buscar</button>
  <button id="check_all_button" v-show="check_all_button_visible" @click="check_all">Seleccionar todo</button>

  <button id="clean_search_button" v-show="search_elements_visible" @click="hide_search">Limpiar</button>
  <input id="search" type="text" v-model="search" v-show="search_elements_visible" :placeholder="search_placeholder"/>
  <div id="clean_filter_modal" v-show="clean_modal_visible">
    <button id="clean_filter_confirm" @click="clean_filter" />
    <button id="clean_filter_cancel" @click="hide_clean_modal" />
  </div>
  <span id="counter" v-if="filter_has_values">{{filter_values_count}}</span>
  <ul id="list" v-show="visible">
    <li :id="calculate_facet_key(facet_value.id, index)" class="facet_value" v-for="facet_value, index in facet.values" :key="calculate_facet_key(facet_value.id, index)">
      <span class="toggler" v-show="toggler_visible(facet_value)" @click="toggle_children(facet_value.id)">Toggle children</span>
      <div :class="facet_value.id" v-show="element_is_visible(facet_value)">
        <input type="checkbox" v-bind:value="facet_value.id" v-model="selected" />
        <label>{{facet_value.name}}</label>
        <label v-if="count_visible(facet_value)">{{facet_value.total}}</label>
      </div>
      <ul class="children" v-show="child_visible(facet_value.id)">
        <li class="child" v-show="element_is_visible(child)" :class="child.id" v-for="child in facet_value.children" :key="child.id">
          <input type="checkbox" v-bind:value="child.id" v-model="selected" />
          <label>{{child.name}}</label>
          <label v-if="count_visible(child)">{{child.total}}</label>
        </li>
      </ul>
    </li>
  </ul>
</div>
</template>

<script>
import Vue from 'vue'
import mixins from 'common/mixins.js'

export default {
  data() {
    return {
      selected: this.values.slice(),
      children_visible: this.parents_for_children_searched(),
      search: '',
      search_visible: false
    }
  },
  components: {
    'forms-tree-node-facet-vue': () => import(/* webpackChunkName: "[request]" */ 'components/forms/TreeNodeFacet'),
  },
  computed: {
    filter_has_values() {
      return this.selected.length > 0
    },
    filter_values_count() {
      return this.selected.length
    },
    is_searching() {
      return this.search.length >= 3
    },
    search_button_visible() {
      return this.visible && !this.search_visible
    },
    search_elements_visible() {
      return this.visible && this.search_visible
    },
    search_placeholder() {
      return this.get_label("find_facet").replace("%", this.facet.name)
    },
    num_checkboxes() {
      var count = 0
      this.facet.values.forEach((parent)=>{
        count += 1 + parent.children.length
      })
      return count
    },
    check_all_button_visible() {
      return this.visible && this.filter_values_count < this.num_checkboxes
    }
  },
  methods: {
    child_visible(child) {
      return this.children_visible.includes(child) || this.is_searching
    },
    toggle_children(child) {
      var index = this.children_visible.indexOf(child)
      if (index > -1)
        this.children_visible.splice(index, 1)
      else
        this.children_visible.push(child)
    },
    is_searched(id) {
      return this.applied_values.includes(id)
    },
    count_visible(facet_value) {
      return this.facet.class_type != 'filter' || this.is_searched(facet_value.id)
    },
    do_clear() {
      this.selected = []
    },
    check_all() {
      this.selected = []
      this.facet.values.forEach((parent) => {
        this.selected.push(parent.id)
        parent.children.forEach((child) => {
          this.selected.push(child.id)
        })
      })
    },
    parents_for_children_searched() {
      var self = this
      var result = []
      this.facet.values.forEach((parent) => {
        if (parent.children.some(r => self.applied_values.includes(r.id)))
          result.push(parent.id)
      })
      return result
    },
    show_search() {
      var self = this
      this.search_visible = true
      Vue.nextTick(() => {
        var ref = Array.isArray(self.$refs.search) ? self.$refs.search[0] : self.$refs.search
        ref.focus()
      })
    },
    hide_search() {
      this.search_visible = false
      this.search = ''
    },
    element_is_visible(element) {
      return !this.is_searching || element.name.match(this.text_to_regex(this.search))
    },
    toggler_visible(element) {
      return !this.is_searching && element.children.length > 0
    },
    update_selected(ids, selected) {
      var updated_list
      if (selected) {
        updated_list = this.selected.concat(ids)
        updated_list = Array.from(new Set(updated_list))
      } else {
        updated_list = this.selected.filter((value) => {return !ids.includes(value)})
      }
      this.selected = updated_list
    },
    calculate_facet_key(facet_id, number) {
      return (facet_id+'_'+number)
    }
  },
  watch: {
    selected(new_value, old_value) {
      this.$emit('update_filter', this.name, new_value.slice(), this.facet.default_operator)
    },
    values(new_value, old_value) {
      if (new_value.length != old_value.length)
        this.selected = new_value
    },
    applied_values(new_value, old_value) {
      if (new_value.length != old_value.length || new_value.some((v,i)=>!old_value.includes(v))) {
        this.children_visible = []
      }
    }
  },
  mixins: [mixins.facet, mixins.regex_utils, mixins.internationalization]
}

</script>